import React, { useRef } from 'react';
import { FaMapMarkerAlt, FaUsers, FaClock } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import { MdArrowBackIos, MdArrowForwardIos } from 'react-icons/md';
import '../Featured/Featured.css';

const featuredData = [
  {
    id: 1,
    img: '/f1.avif',
    title: 'Goa Adventure Beach Tour',
    desc: 'Enjoy thrilling beach adventures, water sports, and vibrant nightlife in sunny Goa.',
    rating: '4.7 (23 Reviews)',
    days: '3 Days - 2 Nights',
    people: '2–18',
    location: 'Baga Beach, Goa',
    price: '₹9,999',
    originalPrice: '₹13,499',
    offer: '26% Off'
  },
  {
    id: 2,
    img: '/f2.avif',
    title: 'Andaman Kayaking Experience',
    desc: 'Paddle through crystal-clear waters and explore the serene mangroves of Andaman.',
    rating: '4.5 (18 Reviews)',
    days: '4 Days - 3 Nights',
    people: '1–12',
    location: 'Havelock Island, Andaman',
    price: '₹12,499',
    offer: null
  },
  {
    id: 3,
    img: '/f3.avif',
    title: 'Himalayan Trek to Triund',
    desc: 'Breathtaking trekking journey to Triund with panoramic views of the Dhauladhar range.',
    rating: '4.6 (31 Reviews)',
    days: '2 Days - 1 Night',
    people: '4–20',
    location: 'Mcleodganj, Himachal Pradesh',
    price: '₹4,999',
    offer: null
  },
  {
    id: 4,
    img: '/f4.avif',
    title: 'Rajasthan Heritage Tour',
    desc: 'Explore majestic forts, palaces, and royal heritage of Jaipur, Jodhpur, and Udaipur.',
    rating: '4.8 (45 Reviews)',
    days: '5 Days - 4 Nights',
    people: '2–25',
    location: 'Jaipur, Rajasthan',
    price: '₹14,999',
    originalPrice: '₹19,999',
    offer: '25% Off'
  },
  {
    id: 5,
    img: '/f5.avif',
    title: 'Backwaters of Kerala',
    desc: 'Experience houseboat stays, lush landscapes, and serene canals in God’s Own Country.',
    rating: '4.4 (29 Reviews)',
    days: '3 Days - 2 Nights',
    people: '2–16',
    location: 'Alleppey, Kerala',
    price: '₹10,499',
    offer: null
  },
  {
    id: 6,
    img: '/f6.avif',
    title: 'Leh-Ladakh Motorbike Expedition',
    desc: 'Ride across rugged terrains, high passes, and mesmerizing valleys of Ladakh.',
    rating: '4.9 (52 Reviews)',
    days: '7 Days - 6 Nights',
    people: '6–14',
    location: 'Leh, Ladakh',
    price: '₹24,999',
    offer: null
  }
];


const Featured = () => {
  const sliderRef = useRef(null);

  const scrollLeft = () => {
    if (sliderRef.current) {
      sliderRef.current.scrollBy({ left: -350, behavior: 'smooth' });
    }
  };

  const scrollRight = () => {
    if (sliderRef.current) {
      sliderRef.current.scrollBy({ left: 350, behavior: 'smooth' });
    }
  };

  return (
    <section className="featured-section">
      <p className="featured-subtitle">Featured Tours</p>
      <h1 className="featured-title">Most Favorite Tour Place</h1>
      <div className="featured-slider-wrapper">
        <button className="slider-arrow left" onClick={scrollLeft}><MdArrowBackIos /></button>
        <div className="featured-slider" ref={sliderRef}>
          {featuredData.map(item => (
            <div className="featured-card" key={item.id}>
              <img src={item.img} alt={item.title} className="card-img" />
              <h2 className="card-title">{item.title}</h2>
              <p className="card-desc">{item.desc}</p>
              <div className="card-info-box">
                <span><FaClock /> {item.days}</span>
                <span><FaUsers /> {item.people}</span>
              </div>
              <div className="card-location"><FaMapMarkerAlt /> {item.location}</div>
              <div className="card-footer">
                <div>
                  {item.offer && <span className="card-offer">{item.offer}</span>}
                  <span className="card-price">{item.price}</span>
                  {item.originalPrice && <span className="card-original">{item.originalPrice}</span>}
                </div>
                <Link to="/contactus">
                <button className="book-btn">Book Now</button>
                </Link>
              </div>
            </div>
          ))}
        </div>
        <button className="slider-arrow right" onClick={scrollRight}><MdArrowForwardIos /></button>
      </div>
    </section>
  );
};

export default Featured;